import VisaImg from '../../../assets/staticImages/visa.png'
import mastercardImg from '../../../assets/staticImages/mastercard.png'
import styles from './PaymentMethods.module.css'
import {MdModeEdit,MdDelete} from 'react-icons/md'
import { SubmitButton, TextComponent } from '../../../components'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PaymentMiddleware } from '../../../Store/Middlewares/PaymentMiddleware'
import { showAlert } from '../../../Store/Actions/GeneralActions'

const methods = [{title:'Visa',img:VisaImg},{title:'Master Card',img:mastercardImg}]

const PaymentMethods = () => {
    const Cards = useSelector(state => state.PaymentReducer.paymentCards);
    const [selectedMethod,setSelectedMethod] = useState()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const {state} = useLocation();
    console.log('state', state);
    // const [loader, setloader] = useState(true)
    useEffect(() => {
        getData()
    }, []);

    const getData = () => {
        dispatch(PaymentMiddleware.getAllCards())
    }
    const onPressDeleteCard = (id, index) => {
        dispatch(PaymentMiddleware.deleteCard(id, index))
    }
    const onPressPayNow = () => {
        if (!selectedMethod) {
            dispatch(showAlert({type: "Error", message: 'Please select a card' }))
        } else {
            let payment_data = { sub_id: state?.id, card_id: selectedMethod?.id }
            dispatch(PaymentMiddleware.payNow(payment_data))
                .then(() => navigate(-1))
                .catch((err) => console.log(err))
        }
    }
    return (
        <>
        <div className={styles.methodsContainer}>
            {Cards.map((item, index)=>{
                const selected = item?.id === selectedMethod?.id
                return (
                    <div className={selected ? `${styles.method} ${styles.selectedMethod}` :styles.method} onClick={()=>setSelectedMethod(item)}>
                        <img className={styles.methodImage} src={item?.brand == "Visa" ? VisaImg : mastercardImg} alt={item?.brand} />
                        <TextComponent text={`*******${item?.card_end_number}`} textClass={styles.methodTitle}/>
                        <div className={styles.methodIcons}>
                            {/* <span className={selected ? `${styles.icon} ${styles.selectedIcon}` :styles.icon}><MdModeEdit/></span> */}
                            <span className={selected ? `${styles.icon} ${styles.selectedIcon}` :styles.icon} onClick={() => onPressDeleteCard(item?.stripe_source_id, index)}><MdDelete/></span>
                        </div>
                    </div>
                )
        })}
        </div>
        <div  className={styles.btnGroup}>
            <SubmitButton title={"Pay Now"} btnClass={styles.solidBtn} onClick={onPressPayNow}/>
            <SubmitButton title={"Add New Card"} btnClass={styles.outlineBtn} outline={true} onClick={()=>navigate('/addNewCard')}/>
        </div>
        </> 
     );
}
 
export default PaymentMethods;